// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"87":"978f10f3","443":"9568fcfd","691":"fe485d1b","942":"e850eab4"}[chunkId] + ".js";
};